const ADACT_FREE_PLAY_DOMAIN = 'https://free-play.lottoland.com';

export { ADACT_FREE_PLAY_DOMAIN };
